// CompanyModal — opened from the user avatar in the header. Surfaces
// the per-Company management surfaces: members + invitations (this pass),
// section access control + general settings (future).

import { createStore } from "./store"
import { api } from "../lib/api"

export const companyModalStore = createStore({
  open: false,
  tab: "members",         // "members" | "invitations"
  memberships: [],
  invitations: [],
  loaded: false,
  loadError: null,
  inviting: false,
  inviteError: null,
})

export function openCompanyModal(tab = "members") {
  companyModalStore.setState({ open: true, tab })
}

export function closeCompanyModal() {
  companyModalStore.setState({ open: false })
}

export function setCompanyModalTab(tab) {
  companyModalStore.setState({ tab })
}

export async function loadCompanyData(paths) {
  try {
    const [members, invites] = await Promise.all([
      api.get(paths.memberships),
      api.get(paths.invitations),
    ])
    companyModalStore.setState({
      memberships: members.memberships || [],
      invitations: invites.invitations || [],
      loaded: true,
      loadError: null,
    })
  } catch (e) {
    companyModalStore.setState({ loadError: e.message, loaded: true })
  }
}

export async function sendInvite(paths, { email, roles }) {
  companyModalStore.setState({ inviting: true, inviteError: null })
  try {
    const { invitation } = await api.post(paths.invitations, {
      invitation: { email, roles },
    })
    companyModalStore.setState((s) => ({
      ...s,
      invitations: [invitation, ...s.invitations],
      inviting: false,
    }))
    return invitation
  } catch (e) {
    companyModalStore.setState({ inviting: false, inviteError: e.message })
    throw e
  }
}
